import React from "react";
import { connect } from "react-redux";
import { Select, Row, Col, notification, PageHeader, Modal, Button, Alert, Tooltip } from "antd";
import { Link, Redirect } from "react-router-dom";
import "./ManageOrderPage.scss";

import OrdersTable from "components/OrdersTable";
import {
  getCustomerOrders,
  cancelOrder,
  getCorporateAccountDetails
} from "api/api";
import { displayGenericError, displaySuccessMessage } from "common/notifications";
import { approvalOrder, authorizelOrder, getAccountBalance, filterOrders, renewAccessToken } from "../../api/api";
import { displayNumberWithComma, formatDouble } from "../../utils/utils";
import CancelOrderModal from "../../components/modal/CancelOrderModal";
import { displayError } from "../../common/notifications";
import OrderSelectionComponent from "../../components/OrderSelectionComponent";
import { DEFAULT_PAGE_NO, DEFAULT_PAGE_SIZE_10 } from "../../common/Const";
import CustomRxPageHeader from "../../rxcomponents/CustomRxPageHeader";

import CurrencySelector from "../../components/CurrencySelector";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

import { ALL_SOURCE_CURRENCY_SUPPORTED, ALL_TARGET_CURRENCY_SUPPORTED } from "../../common/Currency";

import {
  setModalVisible, setRemainingTime, setSourceCurrency, setTargetCurrency, setOrderIds, setOrders,
  setTotalSourceAmount, setTotalConvertedAmount, setTotalTargetAmount, setTotalRemitFees
} from "../../rx/bulkfxupdate";

import BulkFxUpdateRxModal from "../../rxcomponents/BulkFxUpdateRxModal";
import ExportOrderButton from "../../rxcomponents/ExportOrderButton";

const confirm = Modal.confirm;



const CUSTOMER_ORDER_STATUS = ["ALL", "BOOKING", "RECEIVED", "PROCESSING", "COMPLETED", "CANCELED", "PENDING_APPROVAL", "PENDING_AUTHORIZE"];



class ManageOrderPage extends React.Component {

  state = {

    isLoading: true,

    orders: [],

    pagination: {},

    accountStatus: null,
    nextReviewDate:null,

    balanceTitle: '',

    balance: [],

    orderIdSearch: "",

    orderStatus: null,

    sourceCurrency: null,

    targetCurrency: null,

    showSelectOrderCheckbox: false, // used for bulk fx update  

    selectedOrderRowKeys: [],

    selectedOrders: [],

    selectedTotalSourceAmount: 0,

    selectedTotalConvertedAmount: 0,

    selectedTotalTargetAmount: 0,

    selectedTotalRemitFees: 0,

    selectedTotalNumberOfOrders: 0,

    visibleCancelRemark: false,

    clickedSearchButton: false,

    order: null,

    sortField: null,

    sortOrder: null,

    sortClickCount: 0,

  };



  sendEventToGA = (action, category, label, value = null) => {

    if (window.gtag) {

      window.gtag('event', action, {

        'event_category': category,

        'event_label': label,

        'value': value

      });

    } else {

      // console.log("Google Analytics not initialized.");

    }

  }

  handleTableChange = (pagination, filters, sorter) => {
    const pageToFetch = pagination.current - 1;

    const isSortAction = sorter.field || sorter.order;

    if (isSortAction) {
      let { sortField, sortOrder, sortClickCount } = this.state;
      let newSortField = sorter.field || 'orderId';

      if (newSortField !== sortField) {
        sortClickCount = 0;
      }

      sortClickCount = (sortClickCount + 1) % 3;

      if (sorter.order === 'ascend') {
        sortOrder = 'asc';
      } else if (sorter.order === 'descend') {
        sortOrder = 'desc';
      } else {
        newSortField = 'orderId';
        sortOrder = 'desc';
      }

      this.fetch(pageToFetch, pagination.pageSize, newSortField, sortOrder);

      this.setState({
        sortField: newSortField,
        sortOrder: sortOrder,
        sortClickCount: sortClickCount,
      });

      this.sendEventToGA('Manage Order Sort', 'ManageOrderPage', `${newSortField} sorted ${this.state.sortOrder}`);

      // console.log("Updated Sorting:", { newSortField, sortOrder, sortClickCount });
    } else {

      this.fetch(pageToFetch, pagination.pageSize, this.state.sortField, this.state.sortOrder);
    }
  };

  renewAccessToken = () => {

    const intl = this.props.useIntl;

    renewAccessToken(localStorage.getItem("ACCESS_TOKEN")).then(response => {

      localStorage.setItem("ACCESS_TOKEN", response.accessToken);

    }).catch(error => {

      if (error.status === 401) {

        localStorage.removeItem("ACCESS_TOKEN");

        this.props.handleLogout("/", "success", intl.formatMessage({ id: "app.message.sessiontimeout" }));

      }

    })

  }



  componentDidMount() {

    this.renewAccessToken();

    this.fetch(0, 10, 'orderId', 'desc');

    getCorporateAccountDetails()

      .then(({ status , nextReviewDate}) => this.setState({ accountStatus: status, nextReviewDate:nextReviewDate }))

      .catch(displayGenericError);

  }



  componentDidUpdate() {

    if (this.state.orderStatus === 'RECEIVED' && this.state.sourceCurrency && this.state.targetCurrency

      && this.state.sourceCurrency !== 'ALL'

      && this.state.targetCurrency !== 'ALL'

      && this.state.sourceCurrency !== this.state.targetCurrency) {

      this.state.showSelectOrderCheckbox = true;

    } else {

      this.state.showSelectOrderCheckbox = false;

    }

  }



  updateOrder = (id, newOrder) => {

    let newOrders = this.state.orders;

    for (var i = 0; i < newOrders.length; i++) {

      if (newOrders[i].id === id) {

        newOrders[i] = newOrder;

        break;

      }

    }

    this.setState({

      orders: newOrders

    });

  };

  fetch = (page, size, sortKey = this.state.sortField, sortType = this.state.sortOrder) => {

    // console.log("Fetching orders:", { page, size, sortKey, sortType });

    this.setState({ isLoading: true });



    getCustomerOrders(page, size, this.state.orderIdSearch, this.state.orderStatus, this.state.sourceCurrency, this.state.targetCurrency, sortKey, sortType)

      .then(data => {

        this.setState({

          isLoading: false,

          orders: data.data,

          pagination: {

            ...this.state.pagination,

            total: data.total,

            current: page + 1,

          },

        });

      })

      .catch(error => {

        // console.error("Failed to fetch orders:", error);

        this.setState({ isLoading: false });

        displayGenericError(error);

      });

  };

  displayCancelRemark = order => {

    this.setState({

      visibleCancelRemark: true,

      order: order

    }

    )

  }

  closeCancelOrderRemark = () => {

    this.setState({

      visibleCancelRemark: false

    }

    )

  }

  cancelOrderWithRemark = order => {

    const intl = this.props.useIntl;

    if (!order.remarks) {

      displayError(intl.formatMessage({ id: "app.message.manageorderpage.reasonforcancelorder" }));

    } else {

      this.doCancelOrder(order, order.remarks)

      this.closeCancelOrderRemark();

    }

  }

  doCancelOrder = (order, remarks) => {

    const intl = this.props.useIntl;

    this.setState({

      isLoading: true

    });

    cancelOrder(order.id, remarks)

      .then(response => {

        notification.success({

          message: "Brdgx",

          description: intl.formatMessage({ id: "app.message.manageorderpage.ordercancelled" })

        });

        this.setState({

          isLoading: false

        });

        this.updateOrder(order.id, response);

      })

      .catch(error => {

        displayGenericError(error);

        this.setState({

          isLoading: false

        });

      });

  }

  cancelOrder = order => {

    const intl = this.props.useIntl;

    confirm({

      title: intl.formatMessage({ id: "app.message.manageorderpage.cancelorder" }),

      onOk: () => {

        this.doCancelOrder(order, '')

      }

    });

  };

  updateOrderRowKeys = (row) => {

    this.setState({

      selectedOrderRowKeys: row.order,

      selectedOrders: row.selectedOrders,

      selectedTotalSourceAmount: row.totalSourceAmount,

      selectedTotalConvertedAmount: row.totalConvertedAmount,

      selectedTotalTargetAmount: row.totalTargetAmount,

      selectedTotalRemitFees: row.totalRemitFees,

    });

  }

  handleApprovalPendingOrder = () => {

    const intl = this.props.useIntl;

    confirm({

      title: intl.formatMessage({ id: "app.message.manageorderpage.approveorder" }),

      onOk: () => {

        let temp = this.state.selectedOrderRowKeys;

        for (let i = 0; i < temp.length; i++) {

          approvalOrder(temp[i])

            .then(response => {

              this.updateOrder(response.id, response);

            })

            .catch(error => {

              displayGenericError(error);

              this.setState({

                isLoading: false

              });

            });

        }

        this.setState({

          selectedOrderRowKeys: []

        })

      }

    })

  }

  handleAuthorizeOrder = () => {

    const intl = this.props.useIntl;

    confirm({

      title: intl.formatMessage({ id: "app.message.manageorderpage.authorizeorder" }),

      onOk: () => {

        let temp = this.state.selectedOrderRowKeys;

        for (let i = 0; i < temp.length; i++) {

          authorizelOrder(temp[i])

            .then(response => {

              this.updateOrder(response.id, response);

            })

            .catch(error => {

              displayGenericError(error);

              this.setState({

                isLoading: false

              });

            });

        }

        this.setState({

          selectedOrderRowKeys: []

        })

      }

    })

  }



  onConfirmUpdateExchangeRate = () => {

    var newOrders = this.state.orders;

    var bulkFxUpdateOrders = this.props.bulkFxUpdateOrders;

    for (var i = 0; i < newOrders.length; i++) {

      for (var j = 0; j < bulkFxUpdateOrders.length; j++) {

        if (newOrders[i].id === bulkFxUpdateOrders[j].id) {

          newOrders[i].exchangeRate = bulkFxUpdateOrders[j].exchangeRate;

          newOrders[i].targetAmount = bulkFxUpdateOrders[j].targetAmount;

          newOrders[i].indicativeOrder = false;

        }

      }

    }

    this.setState({

      orders: newOrders

    });

  }



  onFieldChanged = (fieldName, newValue) => {

    this.setState({

      [fieldName]: newValue

    })



  };



  onOrderSelected = (order) => {

    this.setState({

      orderIdSearch: order.orderId

    })

  }



  onSearch = () => {

    this.setState({

      isLoading: true,

      selectedOrderRowKeys: [],

      selectedOrders: [],

      selectedTotalSourceAmount: 0,

      selectedTotalConvertedAmount: 0,

      selectedTotalTargetAmount: 0,

      selectedTotalRemitFees: 0,

      selectedTotalNumberOfOrders: 0,

    });

    // console.log("Search Params:", {

    //   page: DEFAULT_PAGE_NO,

    //   size: DEFAULT_PAGE_SIZE_10,

    //   orderIdSearch: this.state.orderIdSearch,

    //   orderStatus: this.state.orderStatus,

    //   sourceCurrency: this.state.sourceCurrency,

    //   targetCurrency: this.state.targetCurrency,

    //   sortKey: this.state.sortKey,

    //   sortType: this.state.sortType

    // });
    this.sendEventToGA('Manage Order Filter', 'ManageOrderPage', 'Filter Search button clicked', 1);

    getCustomerOrders(DEFAULT_PAGE_NO, DEFAULT_PAGE_SIZE_10, this.state.orderIdSearch, this.state.orderStatus, this.state.sourceCurrency, this.state.targetCurrency)

      .then(page => {

        const pagination = { ...this.state.pagination };

        pagination.total = page.total;

        this.setState({

          isLoading: false,

          orders: page.data,

          pagination: pagination,

          clickedSearchButton: true

        });

      })

      .catch(error => {

        this.setState({ isLoading: false });

        displayGenericError(error);

      });

  }



  onBulkFxUpdate = () => {

    const intl = this.props.useIntl;



    // dispatch the action  

    if (this.state.sourceCurrency && this.state.targetCurrency && this.state.orderStatus

      && this.state.sourceCurrency !== 'ALL' && this.state.targetCurrency !== 'ALL' && this.state.orderStatus !== 'ALL'

      && this.state.sourceCurrency !== this.state.targetCurrency) {



      if (!this.state.clickedSearchButton || this.state.selectedOrderRowKeys.length === 0) {

        displayError(intl.formatMessage({ id: "app.message.manageorderpage.notclicksearchbuttonyet" }));



      } else {

        this.props.setOrderIds(this.state.selectedOrderRowKeys);

        this.props.setOrders(this.state.selectedOrders);

        this.props.setSourceCurrency(this.state.sourceCurrency);

        this.props.setTargetCurrency(this.state.targetCurrency);

        this.props.setTotalSourceAmount(this.state.selectedTotalSourceAmount);

        this.props.setTotalTargetAmount(this.state.selectedTotalTargetAmount);

        this.props.setTotalConvertedAmount(this.state.selectedTotalConvertedAmount);

        this.props.setTotalRemitFees(this.state.selectedTotalRemitFees);



        this.props.setRemainingTime(0);



        this.props.setModalVisible(true);

      }



    } else {

      displayError(intl.formatMessage({ id: "app.message.manageorderpage.selectbulkfxupdateinputs" }));

    }

  }



  onClickExport = () => {

    const intl = this.props.useIntl;

    if (!this.state.orders || this.state.orders.length == 0) {

      displayError(intl.formatMessage({ id: "app.common.nodata" }))

    } else {

      // this.props.setDoExport  

    }

  }



  render() {

    const intl = this.props.useIntl;

    const { accountStatus, balance, nextReviewDate } = this.state;



    var isNotReadOnly = this.props.currentUser && !this.props.currentUser.role.readOnly;

    var isFullAccess = this.props.currentUser && this.props.currentUser.role.fullAccess;

    var isApprovalApprover = this.props.currentUser && this.props.currentUser.approval && this.props.currentUser.role.approver;

    var isApprovalAuthorizer = this.props.currentUser && this.props.currentUser.approval && this.props.currentUser.role.authorizer;

    var isApprovalApproverExt = this.props.currentUser && this.props.currentUser.approval && this.props.currentUser.role.approverExt;

    // var isBulkFxUpdate = this.props.currentUser && this.props.currentUser.role.bulkFxUpdate;  



    return (

      <div>

        {(accountStatus === "PREPARING" ||
            accountStatus === "REVIEW_REQUIRED" ||
            accountStatus === "PENDING" || accountStatus === "AWAITING_ACCEPTANCE"
            || accountStatus ==="ACCEPTED" || accountStatus ==="REJECTED"
            || accountStatus ==="BLOCKED" || accountStatus === "REVIEW_OVERDUE") && (
            <div className={"account-verify-status-bar"}>
              { accountStatus ==="PREPARING"  &&(
                  <>
                    <FormattedMessage id="app.message.sendmoneypage.accountnotverified"/>
                    <Link to="/pages/onboarding"><FormattedMessage id="app.page.sendmoneypage.reviewhere"/></Link>
                    &nbsp;<FormattedMessage id="app.page.sendmoneypage.brdgx_contact"/>
                  </>
              )}
              {(accountStatus ==="AWAITING_ACCEPTANCE" || accountStatus ==="ACCEPTED"
                  || accountStatus ==="REJECTED" ||accountStatus ==="PENDING")  &&(
                  <>
                    <FormattedMessage id="app.message.sendmoneypage.submissionunderreview"/>

                  </>
              )}
              {accountStatus ==="REVIEW_REQUIRED" && (
                  <>
                    <FormattedMessage id="app.page.sendmoneypage.reviewrequied"/>
                    &nbsp; {nextReviewDate && (nextReviewDate)}
                    .<Link to="/pages/onboarding"><FormattedMessage id="app.page.sendmoneypage.review_submission"/></Link>
                    &nbsp; <FormattedMessage id="app.page.sendmoneypage.brdgx_contact"/>
                  </>

              )}

              {accountStatus ==="REVIEW_OVERDUE"   &&(
                  <>
                    <FormattedMessage id="app.page.sendmoneypage.review_overdue_contact"/>
                  </>
              )}

              {accountStatus ==="BLOCKED"   &&(
                  <>
                    <FormattedMessage id="app.page.sendmoneypage.blocked_contact"/>
                  </>
              )}


            </div>
        )}

        <CustomRxPageHeader customer={this.props.customer}

          title={intl.formatMessage({ id: "app.sidebar.manageorders" })}

        />



        <div className="bp-page-content bp-page-large">

          <div className="tools-section" style={{ marginBottom: '10px', textAlign: "left" }}>

            <Row gutter={{ xs: 4, sm: 8 }}>

              <Col md={{ span: 4 }} xs={{ span: 18 }}>

                <div>

                  <OrderSelectionComponent onChange={e => this.onFieldChanged('orderIdSearch', e)} onSelected={order => this.onOrderSelected(order)} />

                </div>

              </Col>

              <Col md={{ span: 4 }} xs={{ span: 18 }}>

                <Select

                  className="select-status"

                  size="large"

                  style={{ width: "100%" }}

                  placeholder={intl.formatMessage({ id: "app.page.manageorderpage.selectstatus" })}



                  onChange={status => {

                    this.onFieldChanged("orderStatus", status);

                    this.state.clickedSearchButton = false;

                  }}

                >

                  {CUSTOMER_ORDER_STATUS.map(status => (

                    <Select.Option key={status} value={status}>

                      {status}

                    </Select.Option>

                  ))}

                </Select>

              </Col>

              <Col md={{ span: 4 }} xs={{ span: 18 }}>

                <CurrencySelector placeholder={intl.formatMessage({ id: "app.page.manageorderpage.selectsourcecurrency" })}

                  className="currency-field"

                  style={{ width: "100%" }}



                  currencies={ALL_SOURCE_CURRENCY_SUPPORTED}

                  onCurrencyChanged={newValue => {

                    this.onFieldChanged("sourceCurrency", newValue);

                    this.state.clickedSearchButton = false;

                  }} />

              </Col>

              <Col md={{ span: 4 }} xs={{ span: 18 }}>

                <CurrencySelector placeholder={intl.formatMessage({ id: "app.page.manageorderpage.selecttargetcurrency" })}

                  className="currency-field"

                  style={{ width: "100%" }}



                  currencies={ALL_SOURCE_CURRENCY_SUPPORTED}

                  onCurrencyChanged={newValue => {

                    this.onFieldChanged("targetCurrency", newValue);

                    this.state.clickedSearchButton = false;

                  }} />

              </Col>

            </Row>

            <Row gutter={{ xs: 4, sm: 8 }} style={{ marginTop: '10px' }}>

              <Col className="gutter-row">

                <Button type="primary" htmlType={"button"}

                  onClick={this.onSearch}

                  style={{ marginLeft: '4px', minHeight: '40px' }}>

                  <FormattedMessage id="app.page.manageorderpage.search" />

                </Button>

                {isNotReadOnly && (isFullAccess) && (

                  <Tooltip placement="bottom"

                    title={intl.formatMessage({ id: "app.page.manageorderpage.bulkfx.tips" })}>

                    <Button

                      style={{ marginLeft: '4px', minHeight: '40px' }}

                      htmlType={"button"}

                      type="primary"

                      disabled={true}

                      onClick={null}>

                      <FormattedMessage id="app.page.manageorderpage.bulkfxupdate" />

                    </Button>

                  </Tooltip>

                  /*<Button  

                      style={{marginLeft: '4px', minHeight: '40px'}}  

                      htmlType={"button"}  

                      type="primary"  

                      onClick={this.onBulkFxUpdate}>  

                    <FormattedMessage id="app.page.manageorderpage.bulkfxupdate"/>  

                  </Button>*/

                )}



                {this.props.currentUser && (this.props.currentUser.approval === 'APPROVAL' || this.props.currentUser.approval === 'AUTHORIZE') && (

                  <>

                    {isNotReadOnly && (isFullAccess || isApprovalApprover || isApprovalApproverExt) && (



                      <Button

                        style={{ marginLeft: '4px', minHeight: '40px' }}

                        htmlType={"button"}

                        type="primary"

                        disabled={this.state.selectedOrderRowKeys.length === 0}

                        onClick={this.handleApprovalPendingOrder}>

                        <FormattedMessage id="app.page.manageorderpage.approval" />

                      </Button>

                    )}

                  </>

                )}



                {this.props.currentUser && this.props.currentUser.approval === 'AUTHORIZE' && (

                  <>

                    {isNotReadOnly && (isFullAccess || isApprovalAuthorizer || isApprovalApproverExt) && (



                      <Button

                        style={{ marginLeft: '4px', minHeight: '40px' }}

                        htmlType={"button"}

                        type="primary"

                        disabled={this.state.selectedOrderRowKeys.length === 0}

                        onClick={this.handleAuthorizeOrder}>

                        <FormattedMessage id="app.page.manageorderpage.authorize" />

                      </Button>

                    )}

                  </>

                )}



              </Col>

            </Row>

          </div>



          <OrdersTable

            customer={this.props.customer}

            selectedOrderRowKeys={this.updateOrderRowKeys}

            selectKeys={this.state.selectedOrderRowKeys}

            showSelectOrderCheckbox={this.state.showSelectOrderCheckbox}

            orders={this.state.orders}

            onCancelOrder={this.props.customer.approval ? this.displayCancelRemark : this.cancelOrder}

            pagination={this.state.pagination}

            onChange={this.handleTableChange}

            isLoading={this.state.isLoading}

            onSort={this.sendEventToGA}

          />

          <CancelOrderModal order={this.state.order}

            visible={this.state.visibleCancelRemark}

            onOk={this.cancelOrderWithRemark}

            onCancel={this.closeCancelOrderRemark} />



          <BulkFxUpdateRxModal onConfirmUpdateExchangeRate={this.onConfirmUpdateExchangeRate} setSuccess={() => displaySuccessMessage(intl.formatMessage({ id: "app.modal.bulkfxupdaterxmodal.success" }))} setError={(error) => displayError(error.message)} />

        </div>

      </div>

    );

  }

}



const mapStateToProps = (state) => {

  return {

    lockedExchangeRate: state.bulkFxUpdate.lockedExchangeRate,

    selectedOrderIds: state.bulkFxUpdate.orderIds,

    bulkFxUpdateOrders: state.bulkFxUpdate.orders,

    currentUser: state.user.currentUser

  };

};



const mapDispatchToProps = (dispatch) => {

  return {

    setModalVisible: (modalVisible) => dispatch(setModalVisible(modalVisible)),

    setRemainingTime: (remainingTime) => dispatch(setRemainingTime(remainingTime)),

    setSourceCurrency: (sourceCurrency) => dispatch(setSourceCurrency(sourceCurrency)),

    setTargetCurrency: (targetCurrency) => dispatch(setTargetCurrency(targetCurrency)),

    setOrderIds: (orderIds) => dispatch(setOrderIds(orderIds)),

    setOrders: (orders) => dispatch(setOrders(orders)),

    setTotalSourceAmount: (totalSourceAmount) => dispatch(setTotalSourceAmount(totalSourceAmount)),

    setTotalConvertedAmount: (totalConvertedAmount) => dispatch(setTotalConvertedAmount(totalConvertedAmount)),

    setTotalTargetAmount: (totalTargetAmount) => dispatch(setTotalTargetAmount(totalTargetAmount)),

    setTotalRemitFees: (totalRemitFees) => dispatch(setTotalRemitFees(totalRemitFees)),

  };

};



export default connect(mapStateToProps, mapDispatchToProps)(withUseIntl(ManageOrderPage)); 
